export default {
  enums: [{ id: 'CERTIFICATE' }, { id: 'DECLARATION' }],
};
